import type { MessageKey } from './en.js';

/** Deutsch. Küchensprache, wo es sie gibt: Posten, Gedecke, Mise en place. */
export const de: Record<MessageKey, string> = {
  'common.loading': 'Wird geladen…',
  'common.save': 'Speichern',
  'common.saving': 'Wird gespeichert…',
  'common.saved': 'Gespeichert.',
  'common.cancel': 'Abbrechen',
  'common.edit': 'Bearbeiten',
  'common.delete': 'Löschen',
  'common.reallyDelete': 'Wirklich löschen?',
  'common.remove': 'Entfernen',
  'common.reallyRemove': 'Wirklich entfernen?',
  'common.add': 'Hinzufügen',
  'common.create': 'Anlegen',
  'common.creating': 'Wird angelegt…',
  'common.none': 'Keiner',
  'common.anyone': 'Alle',
  'common.name': 'Name',
  'common.email': 'E-Mail',
  'common.password': 'Passwort',
  'common.station': 'Posten',
  'common.anyStation': 'Jeder Posten',
  'common.anywhere': 'Ohne Posten',
  'common.optional': 'Optional',
  'common.moveUp': 'Nach oben',
  'common.moveDown': 'Nach unten',
  'common.unit': 'Einheit',
  'common.howMuch': 'Wie viel',
  'common.amount': 'Menge',
  'common.working': 'Wird berechnet…',
  'common.dismiss': 'Schließen',
  'common.tryAgain': 'Noch einmal',
  'common.loadFailed':
    'Konnte nicht geladen werden. Prüf die Verbindung und versuch es noch einmal.',

  'error.generic': 'Etwas ist schiefgelaufen.',
  'error.notFound': 'Das gibt es nicht mehr. Vielleicht hat es jemand entfernt.',
  'error.validationFailed': 'Etwas ist nicht richtig ausgefüllt. Prüfe es und versuche es erneut.',
  'error.alreadyExists': 'Das gibt es schon.',
  'error.stillReferenced': 'Das wird noch woanders verwendet und kann nicht entfernt werden.',
  'error.invalidData': 'Dieser Wert ist hier nicht erlaubt.',
  'error.writeInProgress':
    'Diese Änderung wird gerade gespeichert. Versuche es gleich noch einmal.',
  'error.backupFileMissing': 'Hänge die Sicherungsdatei an.',
  'error.onedriveNotConnected': 'Verbinde zuerst OneDrive.',
  'error.nasAddressNeeded': 'Gib die Adresse des NAS ein, an das Sicherungen gehen.',
  'error.fileTooLarge': 'Diese Datei ist zu groß.',
  'error.unknownTimeZone': 'Diese Zeitzone kennt der Server nicht.',
  'error.alreadySetUp': 'Dieser Server ist bereits eingerichtet.',
  'error.imageType': 'Verwende ein JPEG-, PNG- oder WebP-Bild.',
  'error.imageMissing': 'Es wurde kein Bild angehängt.',
  'error.notADish': 'Nur ein Gericht hat eine Gerichtkarte.',
  'error.logoTooLarge': 'Dieses Logo ist größer als 2 MB.',
  'error.photoTooLarge': 'Dieses Bild ist größer als 8 MB.',
  'error.taskNotYours': 'Du kannst nur deinen eigenen Namen an eine Zeile setzen.',
  'error.taskChefOnly':
    'Du kannst eine Zeile beginnen und abschließen, aber nur ein Chef kann ihren Text ändern.',
  'error.staffRank': 'Nur ein Administrator kann Personal deines Rangs oder darüber verwalten.',
  'error.adminNeedsPassword':
    'Ein Administrator braucht E-Mail-Adresse und Passwort, nicht nur eine PIN.',
  'error.passwordNeedsEmail': 'Die Anmeldung mit Passwort braucht eine E-Mail-Adresse.',
  'error.noWayToSignIn':
    'Dann könnte sich die Person nicht mehr anmelden. Gib ihr ein Passwort oder eine PIN.',
  'error.emailTaken': 'Jemand hat diese E-Mail-Adresse schon.',
  'error.lastAdmin':
    'Das ist der letzte Administrator. Mache zuerst jemand anderen zum Administrator, sonst kann niemand diese Küche verwalten.',
  'error.cannotRemoveSelf': 'Du kannst dein eigenes Konto nicht entfernen.',
  'error.onlyDishes': 'Auf ein Menü kommen nur Gerichte: {names}.',
  'error.menuNameTaken': 'Es gibt schon ein Menü mit diesem Namen.',
  'error.menuUnavailable':
    'Die Allergene von {names} lassen sich nicht ermitteln, weil es auf ein Rezept oder eine Zutat verweist, die es nicht mehr gibt. Korrigiere zuerst das Rezept.',
  'error.recipeGone': 'Dieses Rezept gibt es nicht mehr.',
  'error.recipeLoop':
    '{parent} kann {child} nicht enthalten, weil {child} schon {parent} enthält. Das wäre eine Schleife.',
  'error.scaleFailed': 'Dieses Rezept ließ sich für diese Menge nicht berechnen.',
  'error.scaleUnits':
    'Diese Menge ist in einer anderen Art von Einheit als das, was das Rezept ergibt.',
  'error.scaleLoop': 'Dieses Rezept enthält sich selbst und lässt sich daher nicht umrechnen.',
  'error.scaleNoPortions':
    'Dieses Rezept ist nicht in Portionen geschrieben. Rechne es nach Ansatz oder Ertrag um.',
  'error.stillUsed': 'Wird noch verwendet von {names}. Nimm es dort zuerst heraus.',
  'error.alreadyInside': 'Dieses Gerät ist im Küchennetz und braucht keine Freigabe.',
  'error.allergensUnknown':
    'Die Allergene dieses Rezepts lassen sich nicht ermitteln: Etwas fehlt oder verweist auf sich selbst. Prüfe im Editor, was hineinkommt.',
  'error.nameOutsideKitchen':
    'Das Küchenzertifikat gilt nur für das Küchennetz: Adressen wie 192.168.1.50 und Namen auf .local, .lan, .home oder .internal. „{name}“ gehört nicht dazu.',
  'error.invalidCredentials': 'Das passt nicht. Bitte noch einmal versuchen.',
  'error.accountInactive': 'Dieses Konto ist nicht mehr aktiv.',
  'error.deviceNotEnrolled':
    'Die Anmeldung per PIN funktioniert nur auf einem Tablet, das ein Administrator registriert hat.',
  'error.notAuthenticated': 'Bitte anmelden, um fortzufahren.',
  'error.forbidden': 'Deine Rolle erlaubt das nicht.',
  'error.setupToken':
    'Dieser Einrichtungscode stimmt nicht. Sieh im Link nach, der bei der Installation von Mise angezeigt wurde.',
  'error.accountLocked': 'Zu viele falsche Versuche. Versuch es in 15 Minuten noch einmal.',
  'error.accountLockedUntil': 'Zu viele Fehlversuche. Nach {time} erneut versuchen.',

  'shell.unreachableTitle': 'Der Server ist nicht erreichbar',
  'shell.unreachableBody':
    'Prüfe, ob der Mise-Server läuft und ob dieses Gerät im selben Netzwerk ist.',
  'shell.home': 'Mise, heute',
  'shell.signOut': 'Abmelden',
  'shell.signOutFailed':
    'Abmelden hat nicht geklappt. Prüf die Verbindung und versuch es noch einmal.',
  'shell.sourceCode': 'Quellcode',
  'shell.language': 'Sprache',
  'shell.languageKitchen': 'Sprache der Küche ({language})',

  'nav.today': 'Heute',
  'nav.recipes': 'Rezepte',
  'nav.dishes': 'Gerichte',
  'nav.ingredients': 'Zutaten',
  'nav.settings': 'Einstellungen',
  'nav.updateAvailable': 'Eine neuere Mise-Version ist da',

  'role.admin': 'Administrator',
  'role.head_chef': 'Küchenchef',
  'role.sous_chef': 'Sous-Chef',
  'role.cook': 'Koch',

  'recipeType.dish': 'Gericht',
  'recipeType.prep': 'Vorbereitung',
  'recipeType.component': 'Komponente',

  'recipeStatus.draft': 'Entwurf',
  'recipeStatus.published': 'Veröffentlicht',
  'recipeStatus.archived': 'Archiviert',

  'allergen.gluten': 'Glutenhaltiges Getreide',
  'allergen.crustaceans': 'Krebstiere',
  'allergen.eggs': 'Eier',
  'allergen.fish': 'Fisch',
  'allergen.peanuts': 'Erdnüsse',
  'allergen.soybeans': 'Soja',
  'allergen.milk': 'Milch',
  'allergen.nuts': 'Schalenfrüchte',
  'allergen.celery': 'Sellerie',
  'allergen.mustard': 'Senf',
  'allergen.sesame': 'Sesamsamen',
  'allergen.sulphites': 'Schwefeldioxid und Sulfite',
  'allergen.lupin': 'Lupinen',
  'allergen.molluscs': 'Weichtiere',

  'today.night': 'Nacht',
  'today.day': 'Tag',
  'today.progress': '{done} von {total} erledigt',
  'today.progressLabel': 'Mise en place {period} erledigt',
  'today.mine': 'Meins',
  'today.all': 'Alles',
  'today.nothingMine': 'Auf dieser Liste steht nichts von dir.',
  'today.nothingStation': 'Nichts auf diesem Posten.',
  'today.pending_one': 'Ein Haken ist noch nicht beim Server angekommen.',
  'today.pending_other': '{count} Haken sind noch nicht beim Server angekommen.',
  'today.pendingStill': 'Wird erneut versucht. Sie bleiben auf diesem Tablet, bis sie durchgehen.',
  'today.tickRefused': 'Ein Häkchen ist nicht durchgegangen: {reason}',

  'task.doneBy': 'Erledigt von {name}',

  'line.loading': 'Brigade wird geladen…',
  'line.notEnrolledTitle': 'Dieses Tablet ist nicht registriert',
  'line.notEnrolledBody':
    'Die Anmeldung per PIN funktioniert nur auf einem Tablet, das ein Administrator eingerichtet hat. Bitte ihn, sich hier anzumelden und es unter Einstellungen zu registrieren.',
  'line.signInPassword': 'Mit Passwort anmelden',
  'line.whoIsOn': 'Wer ist da?',
  'line.nobodyHasPin':
    'Noch niemand hat eine PIN. Ein Administrator kann unter Einstellungen für jeden Koch eine anlegen.',
  'line.notOnList': 'Nicht auf der Liste, oder am Laptop?',
  'line.signInEmail': 'Mit E-Mail und Passwort anmelden',
  'line.signingIn': 'Anmeldung',
  'line.checking': 'Wird geprüft…',
  'line.notMe': 'Nicht ich',

  'login.title': 'Bei deiner Küche anmelden',
  'login.subtitle': 'Köche mit Leitung und Management, auf jedem Gerät.',
  'login.signIn': 'Anmelden',
  'login.signingIn': 'Anmeldung läuft…',
  'login.onTheLine': 'Auf dem Posten?',
  'login.pinLink': 'Mit deiner PIN anmelden',
  'login.eyebrow': 'E-Mail und Passwort',
  'login.titleKitchen': 'Bei {kitchen} anmelden',
  'login.show': 'Anzeigen',
  'login.hide': 'Verbergen',
  'login.forgot':
    'Passwort vergessen? Ein Administrator kann unter Einstellungen ein neues festlegen.',
  'login.tabletBody': 'Köche melden sich am Küchentablet an: Namen antippen, dann die PIN.',
  'login.server': 'Verbunden mit {host}',
  'line.eyebrow': 'Küchentablet',
  'line.tapNamePin': 'Tipp deinen Namen an, dann deine PIN.',
  'line.enterPin': 'Gib deine PIN ein.',
  'line.digitsTyped_one': '{count} Ziffer eingegeben',
  'line.digitsTyped_other': '{count} Ziffern eingegeben',
  'line.welcome': 'Willkommen, {name}.',
  'line.ok': 'OK',
  'line.clear': 'Löschen',

  'setup.title': 'Diese Küche einrichten',
  'setup.body':
    'Dieser Server ist leer. Gib deiner Küche einen Namen und lege das erste Administratorkonto an. Diese Seite siehst du nur einmal.',
  'setup.kitchenName': 'Name der Küche',
  'setup.kitchenPlaceholder': 'Zum Goldenen Löwen',
  'setup.yourName': 'Dein Name',
  'setup.yourNamePlaceholder': 'Wie die Brigade dich kennt',
  'setup.passwordHint': 'Mindestens 12 Zeichen.',
  'setup.passwordShort': 'Das sind noch weniger als 12 Zeichen.',
  'setup.failed': 'Die Einrichtung ist fehlgeschlagen. Sieh im Serverprotokoll nach.',
  'setup.create': 'Küche anlegen',
  'setup.codeHint':
    'Die Einrichtung von außerhalb des Küchennetzwerks verlangt diesen Code. Es ist SETUP_TOKEN in den Einstellungen von Mise oder das Ende des Links, den das Installationsprogramm angezeigt hat. Wurde keiner gesetzt, hat Mise selbst einen erstellt und in sein Protokoll geschrieben.',
  'setup.codeLabel': 'Einrichtungscode',
  'setup.stepKitchen': 'Restaurant',
  'setup.stepYou': 'Du',
  'setup.stepBrigade': 'Posten & Team',
  'setup.stepRecipes': 'Rezepte',
  'setup.stepSettings': 'Einstellungen',
  'setup.stepCheck': 'Prüfen',
  'setup.stepOf': 'Schritt {current} von {total}',
  'setup.stepShort': 'Schritt {current} / {total}',
  'setup.next': 'Weiter',
  'setup.back': 'Zurück',
  'setup.skip': 'Vorerst überspringen',
  'setup.optional': 'Optional',
  'setup.required': 'Bitte zuerst ausfüllen.',
  'setup.kitchenTitle': 'Wie heißt das Restaurant?',
  'setup.kitchenBody':
    'Dieser Name steht oben auf jedem Bildschirm. Die Sprache wird zur Standardsprache der Küche; jeder kann trotzdem seine eigene wählen.',
  'setup.youTitle': 'Dein Konto',
  'setup.youBody':
    'Du bist der Administrator. Du meldest dich mit dieser E-Mail und diesem Passwort an, auf jedem Gerät.',
  'setup.emailInvalid': 'Das sieht nicht wie eine E-Mail-Adresse aus.',
  'setup.confirmPassword': 'Passwort wiederholen',
  'setup.showPassword': 'Passwort anzeigen',
  'setup.passwordMismatch': 'Die beiden Passwörter stimmen nicht überein.',
  'setup.passwordMatch': 'Die Passwörter stimmen überein.',
  'setup.brigadeTitle': 'Posten und Team',
  'setup.brigadeBody':
    'Posten gliedern jede Mise-en-place-Liste. Fang mit denen an, die du hast; umbenennen oder ergänzen geht jederzeit.',
  'setup.stationsHeading': 'Posten',
  'setup.stationsEmpty': 'Füge mindestens einen Posten hinzu.',
  'setup.stationDuplicate': 'Zwei Posten haben denselben Namen.',
  'setup.staffHeading': 'Team',
  'setup.staffBody':
    'Köche melden sich am Küchentablet an, indem sie ihren Namen antippen und ihre PIN eingeben. Führungskräfte können später unter Einstellungen E-Mail und Passwort bekommen.',
  'setup.staffEmpty':
    'Noch niemand sonst. Füge dein Team jetzt hinzu oder später unter Einstellungen.',
  'setup.addPerson': 'Jemanden hinzufügen',
  'setup.nameMissing': 'Jede Zeile braucht einen Namen.',
  'setup.pinInvalid': 'Eine PIN hat 4 bis 8 Ziffern.',
  'setup.yourPin': 'Deine PIN (optional)',
  'setup.yourPinHint':
    'Damit meldest du dich wie die übrige Brigade am Küchentablet an. Leer lassen zum Überspringen; du kannst sie später festlegen.',
  'setup.summaryPin': 'PIN für das Küchentablet',
  'setup.backupsTitle': 'Sicherungen',
  'setup.backupsHint':
    'Mise sichert jede Nacht die ganze Küche. Eine Kopie woanders sorgt dafür, dass eine kaputte Festplatte oder ein Diebstahl die Sicherungen nicht mitnimmt. Du kannst das später in den Einstellungen ändern.',
  'setup.backupsTestFirst':
    'Teste zuerst die Verbindung zum NAS oder wähle einen anderen Ort für Sicherungen.',
  'setup.backupsConnectFirst':
    'Verbinde zuerst OneDrive oder wähle einen anderen Ort für Sicherungen.',
  'setup.codeForBackups':
    'Nötig, um das NAS zu testen oder OneDrive zu verbinden, wenn du außerhalb des Küchennetzwerks bist. Es ist SETUP_TOKEN in den Einstellungen von Mise oder der Code, den Mise in sein Protokoll geschrieben hat.',
  'setup.recipesTitle': 'Rezepte',
  'setup.recipesBody':
    'Trag die Gerichte und Vorbereitungen, die du schon kennst, ins Rezeptbuch ein: einen Namen und was eine Charge ergibt. Zutaten und Zubereitung können später folgen.',
  'setup.recipesEmpty':
    'Noch keine Rezepte. Du kannst das überspringen und sie später im Rezeptbuch anlegen.',
  'setup.addRecipe': 'Rezept hinzufügen',
  'setup.recipeName': 'Name des Rezepts',
  'setup.recipeType': 'Art',
  'setup.makes': 'Eine Charge ergibt',
  'setup.recipeDuplicate': 'Zwei Rezepte haben denselben Namen.',
  'setup.yieldInvalid': 'Eine Charge muss mehr als 0 ergeben.',
  'setup.settingsTitle': 'So arbeitet diese Küche',
  'setup.settingsBody': 'Das alles lässt sich später unter Einstellungen ändern.',
  'setup.thisDevice': 'Dieses Gerät',
  'setup.enrolDevice': 'Dieses Gerät als Küchentablet verwenden',
  'setup.enrolHint':
    'Das Team kann sich dann mit seiner PIN daran anmelden. Lass das aus, wenn es dein eigenes Handy oder Laptop ist.',
  'setup.deviceName': 'Name des Tablets',
  'setup.checkTitle': 'Prüfen und anlegen',
  'setup.checkBody':
    'Gespeichert wird erst, wenn du auf Anlegen drückst. Geh zu einem Schritt zurück, um etwas zu ändern.',
  'setup.summaryNone': 'Keine',
  'setup.summaryAdmin': '{name} · Administrator',
  'setup.summaryTablet': 'Angemeldet als „{name}“',
  'setup.summaryNoTablet': 'Kein Küchentablet',
  'setup.defaultLarder': 'Kalte Küche',
  'setup.defaultSauce': 'Saucen',
  'setup.defaultSaute': 'Sauté',
  'setup.defaultGrill': 'Grill',
  'setup.defaultPastry': 'Patisserie',
  'welcome.step0': 'Willkommen',
  'welcome.eyebrow': 'Neuer Server · noch nichts eingerichtet',
  'welcome.headline': 'Deine Rezepte und deine Mise en place, auf deinem eigenen Server.',
  'welcome.lead1':
    'Dies ist ein neuer Mise-Server. Die Küche einzurichten dauert etwa fünf Minuten.',
  'welcome.lead2': 'Gespeichert wird erst im letzten Schritt, und alles lässt sich später ändern.',
  'welcome.f1t': 'Rezepturen',
  'welcome.f1b':
    'Auf Ausbeute oder Gästezahl skalieren, Gerichte aus Unterrezepten aufbauen und die Allergene jedes Unterrezepts sehen.',
  'welcome.f2t': 'Eine Mise-en-place-Liste für die Küche',
  'welcome.f2b':
    'Köche tragen ein, was gemacht werden muss, nach Posten. Abgehakte Zeilen verschwinden zwei Stunden später von selbst.',
  'welcome.f3t': 'Die Brigade arbeitet am Tablet',
  'welcome.f3b':
    'Köche melden sich mit einer PIN an, haken Vorbereitungen ab und übernehmen Aufgaben, damit nichts doppelt gemacht wird. Jeder Bildschirm aktualisiert sich live.',
  'welcome.stepsLabel': 'Einrichtung · sechs Schritte',
  'welcome.duration': 'Etwa 5 Minuten',
  'welcome.readyLabel': 'Bereithalten',
  'welcome.r1': 'Den Namen des Restaurants',
  'welcome.r2': 'E-Mail-Adresse und Passwort für dich als Administrator',
  'welcome.r3': 'Deine Posten — Garde-manger, Saucier, Pâtisserie, Pass',
  'welcome.r4': 'Optional dein Team mit je einer 4–8-stelligen PIN und ein paar Rezepte',
  'welcome.changeNote': 'Überspring, was du nicht zur Hand hast. Nichts davon ist endgültig.',
  'welcome.selfHost':
    'Alles, was du eingibst, bleibt auf diesem Server. Es wird nirgendwo sonst ein Konto erstellt, und Mise sendet nichts nach außen.',
  'welcome.cta': 'Diese Küche einrichten',
  'setup.readyLabel': 'Fertig',
  'setup.readyEyebrow': 'Einrichtung abgeschlossen',
  'setup.readyTitle': '{kitchen} ist bereit.',
  'setup.readyBody': 'Die Küche wird geöffnet…',
  'tour.label': 'Tour',
  'tour.promptEyebrow': 'Willkommen, {name}',
  'tour.promptTitle': 'Kurze Tour gefällig?',
  'tour.promptBody':
    'Eine Minute: wo deine Mise-en-place-Liste ist, wie du Aufgaben abhakst und übernimmst, und wo die Rezepte stehen.',
  'tour.promptNote': 'Das fragen wir dich nur einmal.',
  'tour.start': 'Zeig mal',
  'tour.notNow': 'Jetzt nicht',
  'tour.skip': 'Tour überspringen',
  'tour.finish': 'Fertig',
  'tour.welcomeTitle': 'Das ist {kitchen}',
  'tour.welcomeBody':
    'Mise hält die Rezepte und die Mise en place der Küche an einem Ort, auf deinem eigenen Server. Hier findest du alles.',
  'tour.todayBody':
    'Alles, was heute vorbereitet werden muss, nach Posten. Mit dieser Seite arbeitet die Linie.',
  'tour.stationsTitle': 'Dein Posten',
  'tour.stationsBody':
    'Grenz die Liste auf einen Posten ein, oder nur auf die Aufgaben mit deinem Namen.',
  'tour.tickTitle': 'Abhaken',
  'tour.tickBody':
    'Tipp auf eine Zeile, wenn sie erledigt ist. Sie wird sofort auf jedem Bildschirm grau.',
  'tour.makingBody':
    'Fängst du etwas an? Tipp zuerst auf das kleine Häkchen, damit niemand sonst dasselbe macht.',
  'tour.addLineTitle': 'Auf die Liste setzen',
  'tour.addLineBody':
    'Die Mise en place kommt von Hand auf die laufende Liste. Setzt du dasselbe zweimal drauf, wird es in einer Zeile zusammengezählt.',
  'tour.recipesBody':
    'Alle Rezepturen der Küche, mit Allergenen. Auf die nötige Menge skalieren oder für den Pass ausdrucken.',
  'tour.ingredientsBody': 'Woraus die Rezepte bestehen, mit Allergenen und Putzverlust.',
  'tour.settingsBody': 'Posten, Team und PINs, Küchentablets, Gerichtkarten und Sicherungen.',
  'tour.accountTitle': 'Deine Sprache',
  'tour.accountBody': 'Wähl hier deine eigene Sprache, und meld dich nach der Schicht ab.',
  'tour.doneTitle': 'Das war die Tour',
  'tour.doneBody': 'Alles andere findest du in der Leiste oben.',

  'task.remove': '{task} von der Liste nehmen',
  'task.removeConfirm': 'Entfernen?',

  'addTask.what': 'Was zu tun ist',
  'addTask.placeholder': 'Schalotten brunoise',
  'addTask.submit': 'Zeile hinzufügen',
  'addTask.fromBook': 'Aus dem Rezeptbuch',
  'addTask.makes': 'ergibt {amount}',
  'addTask.linked':
    'Mit dem Rezept {name} verknüpft. Wer es macht, öffnet das Rezept in dieser Menge.',
  'task.recipe': 'Rezept',
  'task.openRecipe': 'Rezept für {task} öffnen',

  'recipes.subtitle':
    'Vorbereitungen und Komponenten. Mit Frei von siehst du, was ein Allergietisch bekommen kann, Unterrezepte inklusive. Gerichte haben einen eigenen Reiter.',
  'recipes.search': 'Im Rezeptbuch suchen',
  'recipes.sort': 'Art',
  'recipes.anySort': 'Jede Art',
  'recipes.prep': 'Vorbereitungen',
  'recipes.components': 'Komponenten',
  'recipes.freeFrom': 'Frei von…',
  'recipes.freeFromOption': 'Frei von {allergen}',
  'recipes.clearFreeFrom': 'Nicht mehr nach Allergen filtern',
  'recipes.colSortStation': 'Art · Posten',
  'recipes.colMakes': 'Ergibt',
  'recipes.noMatch': 'Nichts im Rezeptbuch passt.',
  'recipes.empty':
    'Das Rezeptbuch ist leer. Fang mit einem Fond oder einer Sauce an und baue dann die Gerichte, die sie verwenden.',
  'recipes.noStation': 'kein Posten',
  'recipes.noneInTree': 'Frei von {allergen}, Unterrezepte eingeschlossen',
  'recipes.portions_one': '{count} Portion',
  'recipes.portions_other': '{count} Portionen',
  'recipes.countFreeFrom': '{shown} von {total} Rezepten sind frei von {allergen}',
  'recipes.countFiltered': '{shown} von {total} Rezepten',
  'recipes.count_one': '{count} Rezept im Buch',
  'recipes.count_other': '{count} Rezepte im Buch',
  'recipes.new': 'Neues Rezept',

  'recipe.back': '← Das Rezeptbuch',
  'recipe.backToBook': 'Zurück zum Rezeptbuch',
  'recipe.makes': 'Ergibt {amount}',
  'recipe.minutes': '{count} Min.',
  'recipe.keeps_one': 'Hält {count} Stunde',
  'recipe.keeps_other': 'Hält {count} Stunden',
  'recipe.asWritten': 'Wie geschrieben',
  'recipe.scaled': '{factor}× das geschriebene Rezept',
  'recipe.contains': 'Enthält',
  'recipe.nothingDeclarable': 'Nichts zu deklarieren',
  'recipe.mayContain': 'Kann Spuren enthalten von: {allergens}.',
  'recipe.workedOut': 'Aus den Zutaten und allen Unterrezepten berechnet.',
  'recipe.empty': 'Dieses Rezept ist noch leer.',
  'recipe.method': 'Zubereitung',
  'recipe.storage': 'Lagerung',
  'recipe.print': 'Rezeptkarte drucken',
  'recipe.duplicate': 'Duplizieren',
  'recipe.copyName': '{name} (Kopie)',
  'recipe.usedBy': 'Verwendet in',
  'recipe.level': 'Eb.',
  'recipe.what': 'Was',
  'recipe.open': 'öffnen',

  'scale.ask': 'Menge wählen',
  'scale.portions': 'Portionen',
  'scale.need': 'Ich brauche',
  'scale.batches': 'Ansätze',

  'plating.title': 'So geht es raus',
  'plating.alt': 'So geht der Teller raus',
  'plating.remove': 'Foto entfernen',
  'plating.empty': 'Noch kein Foto. Der Teller, den ein Koch nachbaut, kommt hierher, von vorn.',
  'plating.uploading': 'Wird hochgeladen…',
  'plating.add': 'Foto vom Anrichten hinzufügen',
  'plating.addAnother': 'Weiteres Foto hinzufügen',

  'print.whatGoesIn': 'Was hineinkommt',

  'editor.editing': 'Bearbeiten',
  'editor.name': 'Name des Rezepts',
  'editor.namePlaceholder': 'Geflügelvelouté',
  'editor.status': 'Status',
  'editor.lastSaved': 'Zuletzt gespeichert {time}',
  'editor.notSaved': 'Noch nicht gespeichert',
  'editor.colSort': 'Art',
  'editor.colWhat': 'Was es ist',
  'editor.colNote': 'Notiz',
  'editor.sectionHeading': 'Abschnittstitel',
  'editor.removeHeading': 'Titel entfernen',
  'editor.newSection': 'Abschnitt {count}',
  'editor.notePlaceholder': 'fein geschnitten',
  'editor.removeLine': 'Zeile entfernen',
  'editor.addLine': 'Zeile hinzufügen',
  'editor.lines_one': '{count} Zeile',
  'editor.lines_other': '{count} Zeilen',
  'editor.addSection': 'Abschnitt hinzufügen',
  'editor.hintNext': 'nächste Zeile',
  'editor.hintField': 'nächstes Feld',
  'editor.hintMove': 'Zeile verschieben',
  'editor.hintCreate': 'auf einem unbekannten Namen legt ihn an',
  'editor.kindRecipe': 'Rezept',
  'editor.kindIngredient': 'Zutat',
  'editor.kindNew': 'Neu',
  'editor.theRest': 'Der Rest',
  'editor.batchMakes': 'Ein Ansatz ergibt',
  'editor.dishPlates_one': 'Die Mengen gelten für einen Teller.',
  'editor.dishPlates_other': 'Die Mengen gelten für {count} Teller.',
  'editor.yieldUnit': 'Einheit der Ausbeute',
  'editor.prepMinutes': 'Vorbereitung, Minuten',
  'editor.keepsHours': 'Haltbar, Stunden',
  'editor.storagePlaceholder': 'Vakuumiert, Kühlraum, beschriftet',
  'editor.tags': 'Schlagwörter',
  'editor.tagsPlaceholder': 'Pastete, à la carte',
  'editor.mayContain': 'Kann Spuren enthalten · nur Kreuzkontamination',
  'editor.rolledUp': 'Aus den Zeilen zusammengerechnet',
  'editor.rollupUnsaved': 'Speichern, um die Allergene zu berechnen.',
  'editor.rollupContains': 'Enthält {allergens}',
  'editor.rollupNote': 'Stand der letzten Speicherung, Unterrezepte eingeschlossen.',
  'editor.rollupNone': 'Darunter nichts zu deklarieren, Stand der letzten Speicherung.',
  'editor.stepFirst': 'Schalotten in Butter farblos anschwitzen',
  'editor.stepNext': 'Der nächste Schritt',
  'editor.step': 'Schritt {count}',
  'editor.removeStep': 'Schritt {count} entfernen',

  'picker.label': 'Was diese Zeile ist',
  'picker.placeholder': 'Zutat oder Unterrezept',
  'picker.create': 'Zutat anlegen',
  'picker.creating': 'Wird angelegt',

  'ingredients.subtitle':
    'Ausbeute nach dem Putzen, Dichte und Stückgewicht sagen der Liste, wie viel aus dem Kühlhaus geholt werden muss. Zutaten lassen sich auch direkt im Rezepteditor anlegen.',
  'ingredients.search': 'Zutaten suchen',
  'ingredients.new': 'Neue Zutat',
  'ingredients.colYield': 'Ausbeute',
  'ingredients.colDensity': 'g / ml',
  'ingredients.colEach': 'g pro Stück',
  'ingredients.noMatch': 'Nichts gefunden.',
  'ingredients.empty': 'Hier ist noch nichts.',
  'ingredients.explainTitle': 'Wofür die drei Zahlen da sind',
  'ingredients.yieldTitle': 'Ausbeute.',
  'ingredients.yieldBody':
    'Was nach dem Schälen und Putzen übrig bleibt, als Anteil des Eingekauften: ein Kilo Zwiebeln ergibt etwa 900 g Verwertbares.',
  'ingredients.densityTitle': 'Gramm pro Milliliter.',
  'ingredients.densityBody':
    'Lässt ein Rezept in Litern ein Gewicht ergeben, und umgekehrt. Öl liegt bei etwa 0,92.',
  'ingredients.eachTitle': 'Gramm pro Stück.',
  'ingredients.eachBody':
    'Macht aus einer Stückzahl ein Gewicht. Eine Zwiebel wiegt etwa 170, ein Ei etwa 50.',
  'ingredients.byVolume': 'Nach Volumen',
  'ingredients.counted': 'Gezählt',
  'ingredients.weighed': 'Gewogen',
  'ingredients.category': 'Kategorie',
  'ingredients.categoryPlaceholder': 'Gemüse',
  'ingredients.measured': 'Normalerweise gemessen',
  'ingredients.optWeight': 'Nach Gewicht',
  'ingredients.optVolume': 'Nach Volumen',
  'ingredients.optCount': 'Nach Stück',
  'ingredients.yieldLabel': 'Ausbeute, Prozent',
  'ingredients.yieldHint': 'Was nach Schälen und Putzen übrig bleibt. Zwiebeln etwa 90.',
  'ingredients.densityLabel': 'Gramm pro Milliliter',
  'ingredients.densityHint': 'Nur zum Umrechnen zwischen Gewicht und Volumen. Öl etwa 0,92.',
  'ingredients.eachLabel': 'Gramm pro Stück',
  'ingredients.eachHint': 'Nur zum Umrechnen zwischen Stückzahl und Gewicht. Ein Ei etwa 50.',
  'ingredients.allergens': 'Allergene',

  'settings.cookOnly':
    'Nur Küchenchefs und Administratoren können die Einrichtung der Küche ändern.',
  'settings.tabStaff': 'Team',
  'settings.tabStations': 'Posten',
  'settings.tabDevices': 'Geräte',
  'settings.tabKitchen': 'Küche',

  'staff.loadError': 'Die Teamliste konnte nicht geladen werden.',
  'staff.title': 'Team',
  'staff.add': 'Jemanden hinzufügen',
  'staff.you': '(du)',
  'staff.pinTag': 'PIN',
  'staff.passwordTag': 'Passwort',
  'staff.locked': 'Gesperrt',
  'staff.namePlaceholder': 'Wie die Brigade diese Person kennt',
  'staff.role': 'Rolle',
  'staff.station': 'Üblicher Posten',
  'staff.noStation': 'Kein fester Posten',
  'staff.newPin': 'Neue PIN',
  'staff.keepIt': 'Leer lassen, um sie zu behalten',
  'staff.pinPlaceholder': '4 Ziffern',
  'staff.pinHint': 'Zum Anmelden an einem Küchentablet.',
  'staff.passwordSection': 'Anmeldung mit Passwort, für Küchenchefs und Management',
  'staff.newPassword': 'Neues Passwort',
  'staff.passwordPlaceholder': 'Mindestens 12 Zeichen',
  'staff.addSubmit': 'Zur Brigade hinzufügen',

  'stations.loading': 'Posten werden geladen…',
  'stations.loadError': 'Die Posten konnten nicht geladen werden.',
  'stations.title': 'Posten',
  'stations.body':
    'Listen werden nach Posten gruppiert und in dieser Reihenfolge gedruckt, also ordne sie so, wie die Küche aufgebaut ist.',
  'stations.empty':
    'Noch keine Posten. Eine Küche braucht mindestens einen, bevor eine Liste gruppiert werden kann.',
  'stations.addLabel': 'Posten hinzufügen',
  'stations.placeholder': 'Garde-manger',
  'stations.rename': 'Umbenennen',
  'stations.moveEarlier': '{name} nach vorn',
  'stations.moveLater': '{name} nach hinten',

  'devices.title': 'Küchentablets',
  'devices.body':
    'Köche können sich nur auf einem registrierten Tablet per PIN anmelden. Registriere es direkt am Tablet, während du dort als Administrator angemeldet bist.',
  'devices.enrolled': 'Registriert am {date}',
  'devices.lastUsed': 'zuletzt genutzt am {date}',
  'devices.neverUsed': 'nie genutzt',
  'devices.empty': 'Noch keine Tablets registriert, also kann sich niemand per PIN anmelden.',
  'devices.enrolLabel': 'Das Gerät registrieren, an dem du gerade bist',
  'devices.placeholder': 'Tablet am Pass',
  'devices.enrolling': 'Wird registriert…',
  'devices.enrol': 'Dieses Gerät registrieren',
  'devices.enrolledOk': 'Registriert. Dieses Gerät kann jetzt das Team anzeigen und PINs annehmen.',
  'devices.revokedTitle': 'Widerrufen',
  'devices.revokedOn': 'widerrufen am {date}',
  'devices.revoke': 'Widerrufen',
  'devices.reallyRevoke': 'Wirklich widerrufen?',
  'devices.revokeTitle': 'Meldet sofort alle auf {name} ab',

  'kitchen.loadError': 'Die Kücheneinstellungen konnten nicht geladen werden.',
  'version.title': 'Mise-Version',
  'version.running': 'Diese Küche läuft mit Mise {version}.',
  'version.upToDate': 'Das ist die neueste Version.',
  'version.newer': 'Mise {version} ist erschienen.',
  'version.whatChanged': 'Was sich geändert hat',
  'version.checkFailed':
    'GitHub war nicht erreichbar, um nach einer neueren Version zu suchen. Mise versucht es morgen wieder.',
  'version.notChecked':
    'Noch nicht geprüft. Mise schaut eine Minute nach dem Start und danach einmal am Tag.',
  'version.checkLabel': 'Einmal am Tag nach einer neueren Version suchen',
  'version.checkHint':
    'Mise fragt GitHub, welche Version die neueste ist. Über deine Küche wird nichts gesendet.',
  'version.howTitle': 'So aktualisierst du',
  'version.backupFirst':
    'Lade zuerst eine Sicherung herunter. Die Datenbank aktualisiert sich beim Start von Mise selbst.',
  'version.major':
    '{version} ist eine neue Hauptversion. Lies zuerst, was sich geändert hat, und setze MISE_VERSION in .env auf {major}, oder das Image-Tag in TrueNAS auf :{major}.',
  'version.howTrueNas': 'TrueNAS',
  'version.howTrueNasSteps':
    'Öffne Apps, wähle die App mise und klicke auf Update oder Pull Images.',
  'version.howInstaller': 'Mit dem Installationsprogramm installiert',
  'version.howInstallerSteps': 'Führe im Ordner mise-kitchen den Installationsbefehl erneut aus:',
  'version.howDocker': 'Nur Docker',
  'version.howDockerSteps': 'Führe im Ordner mit compose.yaml aus:',
  'kitchen.title': 'Diese Küche',
  'kitchen.units': 'Einheiten',
  'kitchen.metric': 'Metrisch — Gramm und Liter',
  'kitchen.imperial': 'Imperial — Unzen und US-Cups',
  'kitchen.unitsHint':
    'Mit welchen Einheiten neue Rezepte beginnen. Bestehende Rezepte behalten ihre.',
  'kitchen.language': 'Sprache',
  'kitchen.languageHint':
    'Die Sprache der App für alle, die keine eigene gewählt haben. Rezepte bleiben genau so, wie sie eingetippt wurden.',
  'kitchen.retention': 'Verschwundene Zeilen der laufenden Liste',
  'kitchen.retentionKeep': 'In der Datenbank behalten, unsichtbar',
  'kitchen.retentionDelete': 'Löschen, um Speicherplatz zu sparen',
  'kitchen.retentionHint':
    'Behaltene Zeilen zeigen, wer was wann gemacht hat, für spätere Auswertungen, und belegen Speicher. Gelöschte Zeilen sind endgültig weg.',

  'handover.title': 'Übergabe',
  'handover.empty': 'Eine Notiz für die nächste Schicht hinterlassen',
  'handover.placeholder': 'Fisch kommt später; Fond um drei ansetzen.',
  'handover.save': 'Notiz speichern',
  'handover.clear': 'Notiz löschen',
  'handover.edit': 'Ändern',
  'handover.remove': 'Notiz entfernen',
  'handover.removeConfirm': 'Entfernen?',
  'handover.by': '{name}, {when}',
  'running.title': 'Die Liste',
  'running.subtitle':
    'Eine Liste für die ganze Küche. Abgehakte Zeilen verschwinden nach zwei Stunden.',
  'running.empty': 'Nichts auf der Liste. Trag ein, was zu tun ist.',
  'running.merged': 'Zu {name} addiert, das schon auf der Liste stand.',
  'running.goneAt': 'weg um {time}',

  'task.beingMade': 'Wird gemacht',
  'task.beingMadeBy': 'Wird gemacht von {name}',
  'settings.tabBackups': 'Sicherungen',
  'backups.title': 'Sicherungen',
  'backups.body':
    'Jede Nacht speichert Mise die ganze Küche samt Fotos in einer verschlüsselten Datei. Bewahre auch eine Kopie außerhalb dieses Geräts auf.',
  'backups.lastGood': 'Letzte Sicherung: {time}',
  'backups.never': 'Noch keine Sicherung. Die erste läuft in wenigen Minuten.',
  'backups.failed': 'Die letzte Sicherung ist fehlgeschlagen.',
  'backups.reason.bad_key':
    'Ein Wiederherstellungsschlüssel hat 32 Buchstaben und Ziffern in Vierergruppen.',
  'backups.reason.wrong_key':
    'Dieser Schlüssel öffnet die Sicherung nicht, oder die Datei ist beschädigt.',
  'backups.reason.not_a_backup': 'Diese Datei ist keine Mise-Sicherung.',
  'backups.reason.too_new':
    'Diese Sicherung stammt aus einer neueren Mise-Version. Aktualisiere zuerst diesen Server.',
  'backups.reason.local':
    'Sie konnte auf diesem Gerät nicht gespeichert werden. Vielleicht ist der Speicher voll.',
  'backups.reason.unreachable':
    'Mise hat das NAS nicht erreicht. Prüfe die Adresse und ob das NAS eingeschaltet ist.',
  'backups.reason.auth': 'Das NAS hat Benutzername oder Passwort abgelehnt.',
  'backups.reason.folder': 'Diesen Ordner gibt es auf dem NAS nicht. Lege ihn dort zuerst an.',
  'backups.reason.remote': 'Das NAS hat die Datei nicht angenommen.',
  'backups.reason.unknown':
    'Etwas Unerwartetes ist schiefgegangen. Details stehen im Serverprotokoll.',
  'backups.running': 'Sicherung läuft…',
  'backups.now': 'Jetzt sichern',
  'backups.download': 'Herunterladen',
  'backups.keyTitle': 'Wiederherstellungsschlüssel',
  'backups.keyBody':
    'Eine Sicherung lässt sich nur mit diesem Schlüssel öffnen. Druck ihn aus oder schreib ihn auf und bewahre ihn nicht bei diesem Gerät auf. Ohne ihn kann niemand eine Sicherung öffnen.',
  'backups.keyShow': 'Schlüssel anzeigen',
  'backups.keyHide': 'Ausblenden',
  'backups.keyPrint': 'Drucken',
  'backups.keyConfirm': 'Ich habe ihn notiert',
  'backups.keyConfirmed': 'Als notiert markiert.',
  'backups.keyPrintTitle': 'Wiederherstellungsschlüssel für {kitchen}',
  'backups.keyPrintBody':
    'Mit diesem Schlüssel stellst du eine Sicherung dieser Küche in Mise wieder her. Bewahre ihn nicht beim Server auf, sondern im Bürosafe oder zu Hause.',
  'backups.whereTitle': 'Wohin die Sicherungen gehen',
  'backups.onlyHereTitle': 'Sicherungen liegen nur auf diesem Gerät',
  'backups.onlyHereBody':
    'Geht es kaputt, wird es gestohlen oder fällt die Festplatte aus, sind die Sicherungen mit weg. Schicke sie auch an ein NAS oder OneDrive.',
  'backups.onlyHereAction': 'Ziel auswählen',
  'backups.whereLocal': 'Auf diesem Gerät, immer',
  'backups.whereLocalHint':
    'Sie liegen auf demselben Gerät wie Mise. Geht es kaputt, wird es gestohlen oder fällt die Festplatte aus, sind sie mit weg. Lade also ab und zu eine herunter oder schicke sie an ein NAS oder OneDrive.',
  'backups.whereWebdav': 'Auch auf ein NAS oder Nextcloud',
  'backups.whereWebdavHint':
    'Per WebDAV, das Synology, QNAP und Nextcloud anbieten. Eine Kopie bleibt auch auf diesem Gerät.',
  'backups.webdavUrl': 'Adresse des Ordners',
  'backups.webdavUrlHint':
    'Die WebDAV-Adresse eines Ordners, den es schon gibt. Im Restaurant reicht einfaches http://.',
  'backups.webdavUser': 'Benutzername',
  'backups.webdavPassword': 'Passwort',
  'backups.webdavPasswordKept': 'Leer lassen, um das gespeicherte Passwort zu behalten.',
  'backups.test': 'Verbindung testen',
  'backups.testing': 'Wird getestet…',
  'backups.testOk': 'Verbunden. Mise kann in diesen Ordner schreiben.',
  'backups.keepRemote': 'Auf dem NAS behalten',
  'backups.keepLocal': 'Auf diesem Gerät behalten',
  'backups.copies_one': '{count} Sicherung',
  'backups.copies_other': '{count} Sicherungen',
  'backups.when': 'Nächtliche Sicherung um',
  'backups.zone': 'Zeitzone: {zone}.',
  'backups.kept': 'Auf diesem Gerät',
  'backups.keptEmpty': 'Hier liegt noch nichts.',
  'backups.bannerFailed': 'Die letzte Sicherung ist fehlgeschlagen.',
  'backups.bannerStale': 'Seit zwei Tagen gab es keine Sicherung.',
  'backups.bannerKey':
    'Noch hat niemand den Wiederherstellungsschlüssel notiert. Ohne ihn lässt sich keine Sicherung öffnen.',
  'backups.bannerAction': 'Zu den Sicherungen',
  'backups.whereOnedrive': 'Auch auf OneDrive',
  'backups.whereOnedriveHint':
    'In den Ordner Apps/Mise deines OneDrive. Mise sieht sonst nichts in deinem OneDrive. Eine Kopie bleibt auch auf diesem Gerät.',
  'backups.onedriveConnect': 'OneDrive verbinden',
  'backups.onedriveStarting': 'Frage bei Microsoft an…',
  'backups.onedriveCodeIntro':
    'Öffne diese Seite auf einem Handy oder Computer, gib den Code unten ein und melde dich mit dem Microsoft-Konto an, dessen OneDrive die Sicherungen bekommen soll.',
  'backups.onedriveWaiting': 'Warte auf die Anmeldung…',
  'backups.onedriveUnverified':
    'Microsoft bezeichnet Mise als nicht verifiziert. Das ist bei unabhängigen Apps normal, und Mise fragt nur nach seinem eigenen Ordner.',
  'backups.onedriveConnected': 'Verbunden mit dem OneDrive von {account}.',
  'backups.onedriveDisconnect': 'Trennen',
  'backups.onedrive.declined': 'Die Anmeldung wurde bei Microsoft abgelehnt.',
  'backups.onedrive.expired':
    'Der Code ist abgelaufen, bevor sich jemand angemeldet hat. Fang neu an.',
  'backups.onedrive.failed':
    'Microsoft hat die Verbindung nicht angenommen. Versuch es in einer Minute noch einmal.',
  'backups.keepOnedrive': 'Auf OneDrive behalten',
  'backups.keepBoth': 'Auf dem NAS und auf OneDrive behalten',
  'backups.reason.onedrive_auth':
    'OneDrive lässt Mise nicht mehr hinein. Verbinde es auf der Seite Sicherungen neu.',
  'backups.reason.onedrive_full': 'OneDrive ist voll.',
  'backups.reason.onedrive_unreachable':
    'Mise hat OneDrive nicht erreicht. Prüfe die Internetverbindung.',
  'backups.reason.onedrive_failed':
    'OneDrive hat die Sicherung abgelehnt. Mise versucht es in ein paar Stunden noch einmal.',
  'restore.cta': 'Sicherung wiederherstellen',
  'restore.eyebrow': 'Wiederherstellen',
  'restore.title': 'Eine Küche zurückholen',
  'restore.body':
    'Wähle eine Sicherungsdatei und gib den Wiederherstellungsschlüssel ein, der dafür gedruckt wurde. Team, Rezepte, Fotos und Mise-en-place-Listen kommen alle zurück. Danach melden sich alle neu an.',
  'restore.file': 'Sicherungsdatei',
  'restore.key': 'Wiederherstellungsschlüssel',
  'restore.keyHint': 'Großbuchstaben und Bindestriche sind optional.',
  'restore.fileMissing': 'Wähle eine Sicherungsdatei.',
  'restore.keyMissing': 'Gib den Wiederherstellungsschlüssel ein.',
  'restore.submit': 'Wiederherstellen',
  'restore.restoring': 'Wird wiederhergestellt…',
  'restore.working': 'Auf einem kleinen Gerät kann das eine Minute dauern.',
  'restore.done': '{kitchen} ist zurück',
  'restore.doneBody':
    'Melde dich mit derselben E-Mail-Adresse und demselben Passwort an wie vorher. Sicherungen bleiben auf diesem Gerät, bis du in den Einstellungen wieder ein NAS einrichtest.',
  'restore.counts': 'Team: {staff} · Rezepte: {recipes} · Fotos: {photos}',
  'restore.signIn': 'Anmelden',
  'restore.asideTitle': 'Was zurückkommt',
  'restore.asideStaff': 'Das Team mit Passwörtern und PINs',
  'restore.asideRecipes': 'Rezepte, Zutaten und Anrichtefotos',
  'restore.asidePrep': 'Die Mise-en-place-Liste',
  'restore.asideTablets': 'Eingerichtete Tablets, solange der Server seine Adresse behält',

  // Dish cards
  'recipe.dishCard': 'Gerichtkarte',
  'editor.frontOfHouse': 'Service',
  'editor.frontOfHouseHint': 'Was die Gerichtkarte dem Service sagt.',
  'editor.flavour': 'Geschmacksprofil',
  'editor.flavourPlaceholder': 'cremig, Knoblauch, frisch',
  'editor.temperature': 'Serviert',
  'editor.course': 'Platz im Menü',
  'editor.drinks': 'Getränkebegleitung',
  'editor.drinksPlaceholder': 'weißer Bordeaux, Kombucha',
  'editor.cutlery': 'Besteck',
  'editor.cutleryPlaceholder': 'kleiner Löffel',
  'editor.listHint': 'Mit Kommas trennen.',
  'editor.notSet': 'Nicht angegeben',
  'temperature.cold': 'Kalt',
  'temperature.room': 'Zimmertemperatur',
  'temperature.warm': 'Lauwarm',
  'temperature.hot': 'Heiß',
  'temperature.hot_and_cold': 'Heiß und kalt',
  'course.amuse': 'Amuse-Bouche',
  'course.starter': 'Vorspeise',
  'course.middle': 'Zwischengang',
  'course.main': 'Hauptgang',
  'course.pre_dessert': 'Pre-Dessert',
  'course.dessert': 'Dessert',
  'course.mignardise': 'Friandises',
  'course.side': 'Beilage',
  'ingredients.vegan': 'Vegan',
  'ingredients.veganYes': 'Ja',
  'ingredients.veganNo': 'Nein',
  'ingredients.veganUnknown': 'Nicht angegeben',
  'ingredients.veganHint':
    'Eine Gerichtkarte nennt ein Gericht nie vegan, solange eine seiner Zutaten nicht angegeben ist.',
  'ingredients.whichCereals': 'Welches Getreide',
  'ingredients.whichNuts': 'Welche Nüsse',
  'ingredients.cerealsPlaceholder': 'Weizen, Roggen',
  'ingredients.nutsPlaceholder': 'Haselnuss, Walnuss',
  'ingredients.detailsHint':
    'Das Gesetz verlangt, dass Getreide und Nuss auf einer Gerichtkarte beim Namen genannt werden.',
  'card.title': 'Gerichtkarte',
  'card.back': '← Das Gericht',
  'card.language': 'Sprache der Karte',
  'card.theme': 'Aussehen',
  'card.themeDay': 'Tag',
  'card.themeNight': 'Nacht',
  'card.print': 'Drucken',
  'card.download': 'PDF herunterladen',
  'card.downloading': 'PDF wird erstellt…',
  'card.downloadFailed':
    'Das PDF konnte nicht erstellt werden. Noch einmal versuchen oder drucken.',
  'card.notADish': 'Nur ein Gericht hat eine Gerichtkarte.',
  'card.unavailable':
    'Dieses Gericht verweist auf ein Rezept oder eine Zutat, die es nicht mehr gibt, daher lassen sich die Allergene nicht ermitteln. Zuerst das Rezept reparieren.',
  'card.noAccess':
    'In dieser Küche können nur Küchenchefs und Administratoren Gerichtkarten öffnen.',
  'card.attentionTitle': 'Vor dem Drucken prüfen',
  'card.attentionVegan':
    'Bei diesen Zutaten ist nicht angegeben, ob sie vegan sind: {names}. Bis das jemand tut, kann die Karte das Gericht nicht vegan nennen.',
  'card.attentionDetails': 'Diese enthalten Gluten oder Nüsse, ohne zu sagen, welche: {names}.',
  'card.attentionPhoto': 'Dieses Gericht hat noch kein Foto.',
  'card.attentionDraft': 'Dieses Rezept ist noch ein Entwurf.',
  'card.fixIngredients': 'Zu den Zutaten',
  'card.menu': 'Menü',
  'card.flavour': 'Geschmacksprofil',
  'card.temperature': 'Temperatur',
  'card.course': 'Platz im Menü',
  'card.components': 'Komponenten',
  'card.drinks': 'Getränkebegleitung',
  'card.cutlery': 'Besteck',
  'card.allergens': 'Allergene',
  'card.component': 'Komponente',
  'card.vegan': 'Vegan',
  'card.other': 'Weitere Zutaten im Gericht',
  'card.keyContains': 'enthält',
  'card.keyMayContain': 'kann Spuren enthalten',
  'card.keyVegan': 'vegan',
  'card.keyUnknown': 'nicht angegeben',
  'card.cerealsAndNuts': 'Glutenhaltiges Getreide und Nüsse',
  'card.noCerealsOrNuts': 'Kein glutenhaltiges Getreide und keine Nüsse in diesem Gericht.',
  'card.cereals': 'Getreide: {names}',
  'card.nuts': 'Nüsse: {names}',
  'card.unnamed': 'noch nicht genannt',
  'card.printed': 'Gedruckt am {date}',
  'card.page': 'Seite {page} von {pages}',
  'card.madeWithMise': 'Erstellt mit Mise, freie Software unter der AGPL-3.0',
  'card.noAllergens': 'Keines der 14 Allergene',
  'card.notVegan': 'Nicht vegan',
  'card.veganUnknown': 'Vegan: nicht angegeben',
  'cardAllergen.eggs': 'Ei',
  'cardAllergen.gluten': 'Gluten',
  'cardAllergen.lupin': 'Lupine',
  'cardAllergen.milk': 'Milch',
  'cardAllergen.mustard': 'Senf',
  'cardAllergen.sulphites': 'Sulfite',
  'cardAllergen.molluscs': 'Weich\u00adtiere',
  'cardAllergen.fish': 'Fisch',
  'cardAllergen.soybeans': 'Soja',
  'cardAllergen.sesame': 'Sesam',
  'cardAllergen.celery': 'Sel\u00adlerie',
  'cardAllergen.crustaceans': 'Krebs\u00adtiere',
  'cardAllergen.peanuts': 'Erd\u00adnüsse',
  'cardAllergen.nuts': 'Schalen\u00adfrüchte',
  'settings.tabDishCards': 'Gerichtkarten',
  'dishCards.intro':
    'Wie jede Gerichtkarte dieser Küche aussieht. Eine Karte öffnet man bei jedem Gericht.',
  'dishCards.managersOnly':
    'Nur Küchenchefs und Administratoren können das Aussehen der Gerichtkarten ändern.',
  'dishCards.titleLabel': 'Überschrift',
  'dishCards.titleHint': 'Leer lassen für „{default}“.',
  'dishCards.locationName': 'Name des Standorts',
  'dishCards.address': 'Adresse',
  'dishCards.logo': 'Logo',
  'dishCards.logoHint': 'JPEG, PNG oder WebP, bis 2 MB. Quadratisch passt am besten.',
  'dishCards.logoUpload': 'Logo wählen',
  'dishCards.logoReplace': 'Ersetzen',
  'dishCards.logoRemove': 'Entfernen',
  'dishCards.logoNone': 'Noch kein Logo.',
  'dishCards.warning': 'Hinweis unten auf jeder Karte',
  'dishCards.warningHint':
    'In jeder Sprache schreiben, in der gedruckt wird. Eine Karte in einer Sprache ohne Hinweis nimmt den in der Sprache der Küche.',
  'dishCards.warningPlaceholder': 'Diese Gerichtkarte ist Eigentum von …',
  'dishCards.show': 'Auf der Karte',
  'dishCards.part.menu': 'Menü',
  'dishCards.part.flavour': 'Geschmacksprofil',
  'dishCards.part.temperature': 'Temperatur',
  'dishCards.part.course': 'Platz im Menü',
  'dishCards.part.drinks': 'Getränkebegleitung',
  'dishCards.part.cutlery': 'Besteck',
  'dishCards.part.photo': 'Foto',
  'dishCards.part.logo': 'Logo',
  'dishCards.part.location': 'Standort und Adresse',
  'dishCards.part.summary': 'Allergene auf der Vorderseite',
  'dishCards.part.mayContain': 'Hinweise „kann enthalten“',
  'dishCards.part.vegan': 'Spalte vegan',
  'dishCards.theme': 'Aussehen',
  'dishCards.themeDayHint': 'Weiß, sparsam mit Toner.',
  'dishCards.themeNightHint': 'Dunkel, am schönsten am Bildschirm oder auf einem Farblaser.',
  'dishCards.access': 'Wer Gerichtkarten öffnen kann',
  'dishCards.accessEveryone': 'Alle Angemeldeten',
  'dishCards.accessManagers': 'Nur Küchenchefs und Administratoren',
  'dishCards.miseLine':
    'Jede Karte endet mit einer kleinen Zeile, dass sie mit Mise erstellt wurde.',
  // Menus
  'nav.menus': 'Menüs',
  'dishes.subtitle':
    'Jedes Gericht als seine Karte: was der Service liest, mit den Allergenen aus jedem Unterrezept berechnet.',
  'dishes.new': 'Neues Gericht',
  'dishes.search': 'Gericht suchen',
  'dishes.anyCourse': 'Jeder Gang',
  'dishes.onMenu': 'Nur auf einem aktiven Menü',
  'dishes.noMatch': 'Kein Gericht passt.',
  'dishes.empty':
    'Noch keine Gerichte. Ein Gericht ist, was an den Pass geht: Leg eins an, dann steht es hier als seine Karte.',
  'dishes.count_one': '{count} Gericht',
  'dishes.count_other': '{count} Gerichte',
  'dishes.countFreeFrom': '{shown} von {total} Gerichten sind frei von {allergen}',
  'dishes.countFiltered': '{shown} von {total} Gerichten',
  'dishes.notOnMenu': 'Auf keinem Menü',
  'dishes.broken':
    'Die Allergene lassen sich nicht berechnen: Ein Unterrezept fehlt oder verwendet sich selbst.',
  'dishes.openSpec': 'Rezept',
  'dishes.print': 'Drucken oder PDF',
  'dishes.kept':
    'Diese Küche behält Gerichtekarten Köchen und Administratoren vor. Das Rezept kannst du trotzdem öffnen.',
  'menus.subtitle':
    'Die Gerichte, die der Service zusammen verkauft. Die Allergenübersicht eines Menüs drucken, oder alle Gerichtkarten auf einmal.',
  'menus.name': 'Name des Menüs',
  'menus.namePlaceholder': 'Herbstmenü 2026',
  'menus.new': 'Neues Menü',
  'menus.empty': 'Noch keine Menüs. Oben eines mit einem Namen anlegen.',
  'menus.dishes_one': '{count} Gericht',
  'menus.dishes_other': '{count} Gerichte',
  'menuStatus.draft': 'Entwurf',
  'menuStatus.active': 'Aktiv',
  'menuStatus.archived': 'Archiviert',
  'menus.back': '← Menüs',
  'menus.dishesTitle': 'Auf dem Menü',
  'menus.changedCount_one': '{count} geändert, seit die Karten gedruckt wurden',
  'menus.changedCount_other': '{count} geändert, seit die Karten gedruckt wurden',
  'menus.noDishes': 'Noch keine Gerichte auf diesem Menü.',
  'menus.noCourse': 'Ohne Gang',
  'menus.changed': 'Geändert',
  'menus.removeDish': '{name} vom Menü nehmen',
  'menus.addDish': 'Gericht hinzufügen',
  'menus.pickDish': 'Ein Gericht wählen',
  'menus.allDishesOn': 'Alle Gerichte sind schon auf diesem Menü.',
  'menus.status': 'Status',
  'menus.description': 'Beschreibung',
  'menus.descriptionPlaceholder':
    'Ein paar Worte für den Service, etwa der Preis oder wann es läuft.',
  'menus.overview': 'Allergenübersicht',
  'menus.cardsTitle': 'Gerichtkarten',
  'menus.cardsProgress': 'Karte {done} von {total}…',
  'menus.allCards': 'Alle Gerichtkarten (PDF)',
  'menus.lastPrinted': 'Karten zuletzt heruntergeladen am {when}.',
  'menus.neverPrinted': 'Die Gerichtkarten dieses Menüs wurden noch nicht heruntergeladen.',
  'menus.copyName': 'Name der Kopie',
  'menus.copyPlaceholder': '{name} (Kopie)',
  'menus.duplicate': 'Menü kopieren',
  'menus.delete': 'Menü löschen',
  'menus.backToMenu': '← Das Menü',
  'menus.overviewTitle': 'Allergenübersicht',
  'menus.dish': 'Gericht',
  'access.eyebrow': 'Außerhalb der Küche',
  'access.title': 'Zugang anfragen',
  'access.body':
    'Außerhalb der Küche öffnet sich Mise nur auf Geräten, die die Küche freigegeben hat. Gib diesem Gerät einen Namen und frag an. Ein Koch mit Leitung oder der Administrator gibt es unter Einstellungen → Geräte frei.',
  'access.nameLabel': 'Name für dieses Gerät',
  'access.namePlaceholder': 'z. B. Sams Handy',
  'access.ask': 'Zugang anfragen',
  'access.asking': 'Wird angefragt…',
  'access.waitingTitle': 'Warten auf Freigabe',
  'access.waitingBody':
    '„{name}“ hat angefragt. Bitte einen Koch mit Leitung oder den Administrator, es unter Einstellungen → Geräte freizugeben, und lies diesen Code vor, damit klar ist, dass du es bist:',
  'access.codeLabel': 'Code',
  'access.checking': 'Diese Seite öffnet Mise von selbst, sobald es freigegeben ist.',
  'access.whyTitle': 'Warum anfragen?',
  'access.whyBody':
    'Rezepte, Team und Allergene gehören der Küche. Erst anfragen heißt: Niemand im Internet kommt auch nur bis zur Anmeldeseite. Die Freigabe gilt, bis sie widerrufen wird oder dieses Gerät 90 Tage nicht benutzt wurde.',
  'outside.title': 'Außerhalb der Küche',
  'outside.body':
    'Handys und Laptops außerhalb des Küchennetzes oder VPN. Sie sehen nur eine Anfrageseite, bis jemand sie hier freigibt. Die Freigabe gilt, bis du sie widerrufst oder das Gerät 90 Tage nicht benutzt wurde.',
  'outside.waiting': 'Warten auf Freigabe',
  'outside.approved': 'Freigegeben',
  'outside.empty':
    'Keine Geräte von außen. Wer Mise außerhalb der Küche öffnet, kann Zugang anfragen; die Anfrage erscheint hier.',
  'outside.code': 'Code',
  'outside.checkCode':
    'Gib nur frei, wenn die anfragende Person genau diesen Code auf dem Bildschirm sieht.',
  'outside.passwordLabel': 'Dein Passwort',
  'outside.passwordWhy':
    'Du bist außerhalb der Küche, deshalb fragt die Freigabe erneut nach deinem Passwort.',
  'outside.approve': 'Freigeben',
  'outside.deny': 'Ablehnen',
  'outside.approvedBy': 'freigegeben von {name} am {date}',
  'outside.approvedByFrom': 'freigegeben von {name} über {device} am {date}',
  'outside.approvedOn': 'freigegeben am {date}',
  'outside.thisDevice': 'Dieses Gerät',
  'outside.revokeSelf': 'Dieses Gerät muss danach neu anfragen',
  'outside.reallyRevokeSelf': 'Dieses Gerät aussperren?',
  'error.accessRequired':
    'Dieses Gerät ist nicht für den Zugang von außerhalb der Küche freigegeben.',
  'error.wrongPassword': 'Das Passwort stimmt nicht.',
  'error.passwordNeeded':
    'Freigeben von außen braucht ein Passwort, und dieses Konto hat keins. Gib es aus der Küche frei.',
  'error.tooManyRequests': 'Zu viele Geräte warten auf Freigabe. Versuch es später noch einmal.',
  'settings.tabConnection': 'Verbindung',
  'connection.relayedTitle': 'Mise kann nicht erkennen, wer in der Küche ist',
  'connection.relayedBody':
    'Manche Besucher erreichen Mise über Dockers eigene Weiterleitung ({address}), die verbirgt, wo sie wirklich sind. Deshalb zählt Mise sie als außerhalb der Küche: Jedes Gerät bittet einmal um Zugang, und ein Chef gibt es frei.',
  'connection.relayedTrusted':
    'Manche Besucher erreichen Mise über Dockers eigene Weiterleitung ({address}), die verbirgt, wo sie wirklich sind. Du hast gewählt, sie zur Küche zu zählen, also überspringen sie die Freigabe, die Geräte von außen brauchen, wo immer sie sind.',
  'connection.relayedTrust': 'Diese Besucher zur Küche zählen',
  'connection.relayedTrustHint':
    'Nur wenn Mise aus dem Internet nicht erreichbar ist, oder nur über einen Webserver, dem du vertraust. Sonst überspringt jeder, der es findet, die Freigabe.',
  'connection.relayedFix':
    'Das passiert mit rootless Docker, Podman, Docker Desktop oder über IPv6, wenn Dockers Netzwerk keins hat. Starte Mise mit Host-Netzwerk (network_mode: host) oder schalte IPv6 für Dockers Netzwerk ein, damit Mise die eigene Adresse jedes Besuchers sieht. Siehe „From outside the kitchen“ in der README.',
  'connection.domainTitle': 'Adresse von außen',
  'connection.domainBody':
    'Wenn Mise über das Internet erreichbar ist, trag die Adresse ein, die dorthin führt, etwa mise.deinekueche.de. Von außerhalb der Küche antwortet Mise dann nur unter dieser Adresse: die bloße IP oder der Name einer anderen Website auf demselben Server findet nichts. Im Küchennetz und im VPN funktioniert weiterhin jede Adresse.',
  'connection.domainLabel': 'Domain',
  'connection.domainSet': 'Von außen antwortet Mise nur unter {domain}.',
  'connection.domainUnset':
    'Nicht gesetzt: Von außen führt jede Adresse, die diesen Server erreicht, zu Mise.',
  'connection.domainClear': 'Leeren',
  'connection.domainUseCurrent': '{domain} verwenden, die aktuelle Adresse',
  'connection.domainShared':
    'Andere Websites auf derselben öffentlichen IP? Was sie bereits ausliefert (Apache, LiteSpeed oder Nginx, oft über ein Panel wie cPanel oder Plesk eingerichtet), muss diese Domain an Mise weiterreichen und dabei den Domainnamen in der Anfrage behalten. Läuft Mise über einen anderen Anschluss als diese Seiten, ist nichts weiter nötig.',
  'error.domainLocksYouOut':
    'Du bist über eine andere Adresse verbunden und würdest dich aussperren. Stell es aus der Küche ein oder öffne Mise zuerst über die neue Adresse.',
  'proxy.title': 'Hinter einem anderen Webserver',
  'proxy.body':
    'Beantwortet schon ein anderer Webserver in deinem Netz (etwa Apache mit deinen Websites) deine Domains? Lass ihn deine Mise-Domain weiterreichen, mit eigenem Zertifikat. Mise muss dann wissen, welche Maschine das ist, um zu erkennen, wer zu Hause ist und wer draußen.',
  'proxy.trusted': 'Mise glaubt {address}, wer jeder Besucher ist.',
  'proxy.none':
    'Kein Webserver vertraut: Alles, was über eine andere Maschine kommt, gilt als draußen.',
  'proxy.stop': 'Nicht mehr vertrauen',
  'proxy.seen': 'Anfragen für {host} kommen über {address}. Ist das dein Webserver?',
  'proxy.trust': '{address} vertrauen',
  'proxy.addressLabel': 'Oder gib die Adresse des Webservers ein',
  'proxy.trustTyped': 'Vertrauen',
  'proxy.apacheTitle': 'Apache einrichten',
  'proxy.miseAddress': 'Mise in deinem Netz',
  'proxy.step1': 'Prüf auf der Apache-Maschine, ob sie Mise erreicht. Das sollte „ok“ ausgeben:',
  'proxy.step1Bridge':
    'Apache in einer VM auf derselben TrueNAS wie Mise, und es kommt nichts zurück? TrueNAS-VMs erreichen ihren eigenen Host oft nicht. Leg unter Network in TrueNAS eine Bridge (br0) an, verschieb die Adresse des Hosts darauf und häng die Netzwerkkarte der VM an br0.',
  'proxy.step2': 'Speichere das als /etc/apache2/sites-available/mise.conf:',
  'proxy.step3': 'Schalte es ein und hol das Zertifikat, wie bei deinen anderen Seiten:',
  'proxy.step4':
    'Öffne einmal https://{domain} und komm dann zurück: Mise zeigt die Adresse, über die es kam, und du vertraust ihr.',
  'proxy.router':
    'Am Router ändert sich nichts: Port 80 und 443 gehen schon zu Apache. Lass die Domain auf deine IP zu Hause zeigen, wie deine anderen Seiten.',
  'proxy.copy': 'Kopieren',
  'proxy.copied': 'Kopiert',
  'error.proxyNotLocal': 'Nimm die Adresse eines Webservers im Küchennetz, etwa 192.168.1.60.',
  'https.title': 'HTTPS',
  'https.body':
    'Normales HTTP funktioniert weiterhin. HTTPS lässt Tablets offline weiterarbeiten und Mise als App installieren, und es ist Pflicht für alles, was aus dem Internet erreichbar ist.',
  'https.on': 'An',
  'https.off': 'Aus',
  'https.kitchenTitle': 'Im Küchennetz',
  'https.kitchenBody':
    'Mise erstellt ein eigenes Zertifikat für die Adressen, die deine Tablets nutzen. Keine Domain, kein Internet nötig. Jedes Tablet vertraut ihm einmal, über die Vertrauensseite.',
  'https.renews': 'Erneuert sich selbst. Das aktuelle gilt bis {date}.',
  'https.trustEachTablet': 'Öffne auf jedem Tablet einmal diese Seite und folge den Schritten:',
  'https.namesLabel': 'Adressen, die die Tablets nutzen',
  'https.namesHint':
    'Die Adresse in der Adressleiste der Tablets, ohne http:// oder Port. Mehrere? Mit Kommas trennen.',
  'https.making': 'Wird erstellt…',
  'https.turnOn': 'Einschalten',
  'https.turnOff': 'Ausschalten',
  'https.updateNames': 'Adressen aktualisieren',
  'https.portNote':
    'HTTPS antwortet auf Port {port}. Auf TrueNAS muss die App diesen Port auch freigeben.',
  'https.domainTitle': 'Für deine Domain',
  'https.domainTitleFor': 'Für {domain}',
  'https.domainBody':
    'Ein kostenloses Zertifikat von Let’s Encrypt, dem jeder Browser ohne Schritte am Gerät vertraut. Mise holt und erneuert es selbst.',
  'https.domainNeedsAddress': 'Leg zuerst oben die Adresse von außen fest.',
  'https.domainBehindProxy':
    'Mise steht hinter deinem eigenen Webserver, der HTTPS für diese Domain übernimmt. Das brauchst du nicht.',
  'https.domainStep1': '{domain} zeigt auf deine öffentliche IP-Adresse.',
  'https.domainStep2':
    'Dein Router leitet Port 80 an Mises Port {http} weiter und Port 443 an Port {https}. Auf einem Cloud-Server erledigt das die Installation.',
  'https.domainStep3': 'Dann das Zertifikat anfordern:',
  'https.getCertificate': 'Zertifikat holen',
  'https.asking': 'Let’s Encrypt wird gefragt…',
  'https.askingNote': 'Das dauert meist ein paar Sekunden, höchstens zwei Minuten.',
  'https.failedHint':
    'Meist erreicht Port 80 Mise noch nicht, oder die Domain zeigt noch nicht hierher. Let’s Encrypt erlaubt nur wenige Fehlversuche pro Stunde.',
  'https.renewFailed': 'Die letzte Erneuerung schlug fehl; Mise versucht es erneut: {reason}',
  'trust.eyebrow': 'Dieses Gerät',
  'trust.title': 'Dem Küchenzertifikat vertrauen',
  'trust.body':
    'Einmal pro Gerät. Danach öffnet sich Mise hier über HTTPS, läuft weiter, wenn das Netz ausfällt, und lässt sich als App installieren.',
  'trust.notOn':
    'HTTPS ist noch nicht an. Ein Administrator schaltet es unter Einstellungen → Verbindung ein.',
  'trust.trusted': 'Dieses Gerät vertraut ihm',
  'trust.trustedBody': 'Du bist über HTTPS bei Mise. Nutze ab jetzt diese Adresse.',
  'trust.openMise': 'Mise öffnen',
  'trust.system.ios': 'iPad / iPhone',
  'trust.system.android': 'Android',
  'trust.system.windows': 'Windows',
  'trust.system.mac': 'Mac',
  'trust.system.other': 'Andere',
  'trust.download': 'Lade das Küchenzertifikat herunter.',
  'trust.downloadIos':
    'Lade das Zertifikat in Safari herunter und erlaube es, wenn nach einem Konfigurationsprofil gefragt wird.',
  'trust.downloadButton': 'Zertifikat herunterladen',
  'trust.ios1':
    'Öffne Einstellungen, tippe oben auf „Profil geladen“, dann auf Installieren, und gib deinen Code ein.',
  'trust.ios2': 'Geh zu Einstellungen → Allgemein → Info → Zertifikatsvertrauenseinstellungen.',
  'trust.ios3': 'Aktiviere volles Vertrauen für „Mise“.',
  'trust.android1':
    'Öffne Einstellungen und suche nach „CA-Zertifikat“ (oft unter Sicherheit → Verschlüsselung & Anmeldedaten → Zertifikat installieren).',
  'trust.android2':
    'Wähle „CA-Zertifikat“, tippe auf „Trotzdem installieren“ und wähle mise-kitchen.crt aus deinen Downloads.',
  'trust.windows1':
    'Öffne die heruntergeladene Datei, wähle „Zertifikat installieren“, dann „Aktueller Benutzer“.',
  'trust.windows2':
    'Wähle „Alle Zertifikate in folgendem Speicher speichern“, nimm „Vertrauenswürdige Stammzertifizierungsstellen“, schließ ab und starte den Browser neu.',
  'trust.mac1':
    'Öffne die heruntergeladene Datei. Die Schlüsselbundverwaltung fügt es deinem Anmeldeschlüsselbund hinzu.',
  'trust.mac2':
    'Doppelklicke auf „Mise“, öffne Vertrauen und stell „Bei Verwendung dieses Zertifikats“ auf „Immer vertrauen“.',
  'trust.other1':
    'Füge die Datei den vertrauenswürdigen Zertifizierungsstellen des Systems oder Browsers hinzu. Firefox hat eine eigene Liste: Einstellungen → Datenschutz & Sicherheit → Zertifikate → Zertifizierungsstellen → Importieren.',
  'trust.check':
    'Prüfe, ob es geklappt hat: Das öffnet diese Seite über HTTPS. Eine Warnung heißt, dass ein Schritt fehlt.',
  'trust.checkButton': 'Prüfen',
  'trust.fingerprint': 'Fingerabdruck zum Vergleichen',
  'error.badName':
    'Das ist keine Adresse und kein Hostname. Nimm etwa 192.168.1.50 oder mise.local.',
  'error.noDomain': 'Leg zuerst die Adresse von außen fest.',
  'offline.title': 'Offline.',
  'offline.body':
    'Mise ist seit {time} nicht erreichbar. Du siehst, was dieses Gerät hatte, und Änderungen bleiben hier, bis Mise wieder antwortet.',
  'offline.waiting_one': '1 Änderung wartet.',
  'offline.waiting_other': '{count} Änderungen warten.',
  'offline.sending_one': '1 offline gemachte Änderung wird gesendet…',
  'offline.sending_other': '{count} offline gemachte Änderungen werden gesendet…',
  'offline.dropped': '{what} konnte nicht gespeichert werden: {reason}',
  'offline.setAside':
    '{what} konnte nicht gespeichert werden: Mise hatte damit ein Problem. Andere Änderungen gehen weiter.',
  'offline.tryAgain': 'Erneut versuchen',
  'offline.letGo': 'Verwerfen',
  'offline.lineWaiting': 'Wartet auf Senden',
  'offline.allergensOnceSent':
    'Allergene werden aktualisiert, sobald deine Änderungen gesendet sind.',
  'offline.cardOnceSent': 'Diese Karte wird aktualisiert, sobald deine Änderungen gesendet sind.',
  'offline.menuOnceSent':
    'Allergene und Gerichtkarten werden aktualisiert, sobald deine Änderungen gesendet sind.',
  'offline.conflictTitle': 'Auf einem anderen Gerät geändert',
  'offline.conflictBody':
    'Während du offline warst, hat jemand anderes {what} geändert. Welche Version soll bleiben?',
  'offline.yours': 'Deine',
  'offline.theirs': 'Jetzt in Mise',
  'offline.keepMine': 'Meine behalten',
  'offline.keepTheirs': 'Die in Mise behalten',
  'offline.items_one': '1 Eintrag',
  'offline.items_other': '{count} Einträge',
  'offline.field.note': 'Notiz',
  'offline.field.notes': 'Notizen',
  'offline.field.method': 'Zubereitung',
  'offline.field.description': 'Beschreibung',
  'offline.field.tags': 'Schlagwörter',
  'offline.field.components': 'Bestandteile',
  'offline.field.dishes': 'Gerichte',
  'offline.field.type': 'Rezeptart',
  'offline.field.yield': 'Ergibt',
  'offline.field.portions': 'Portionen',
  'offline.field.prepMinutes': 'Vorbereitungszeit',
  'offline.field.cookMinutes': 'Garzeit',
  'offline.field.keeps': 'Haltbar',
  'offline.field.allergens': 'Allergene',
  'offline.field.mayContain': 'Kann enthalten',
  'offline.yes': 'Ja',
  'offline.no': 'Nein',
  'offline.unknownStation': 'Ein inzwischen entfernter Posten',
  'offline.label.note': 'die Übergabenotiz',
  'offline.label.addLine': 'die Prep-Zeile „{name}“',
  'offline.label.editLine': 'eine Änderung an einer Prep-Zeile',
  'offline.label.removeLine': 'das Entfernen einer Prep-Zeile',
  'offline.label.recipe': 'das Rezept „{name}“',
  'offline.label.menu': 'die Karte „{name}“',
  'offline.label.ingredient': 'die Zutat „{name}“',
  'error.offline':
    'Mise ist gerade nicht erreichbar, und dafür braucht es die Verbindung. Versuch es erneut, sobald sie zurück ist.',
  'prepPrint.print': 'Drucken',
  'prepPrint.title': 'Vorbereitungsliste',
  'prepPrint.empty': 'Nichts auf der Liste.',
  'prepPrint.line': '{name}, {amount}',
  'recipeCard.makes': 'Ergibt',
  'recipeCard.prepTime': 'Zubereitung',
  'recipeCard.keeps': 'Haltbar',
  'recipeCard.days_one': '{count} Tag',
  'recipeCard.days_other': '{count} Tage',
  'recipeCard.hours_one': '{count} Stunde',
  'recipeCard.hours_other': '{count} Stunden',
  'recipeCard.mayContain': 'Kann enthalten: {allergens}',
  'recipeCard.onThePlate': 'Auf dem Teller',
  'recipeCard.plating': 'Anrichten',
  'recipeCard.ownRecipe': 'eigenes Rezept',
  'updated.title': 'Mise wurde aktualisiert',
  'updated.body':
    'Mise wurde aktualisiert. Lade neu, um die neue Version zu nutzen; nichts, was noch gesendet werden muss, geht verloren.',
  'updated.bodyVersion':
    'Mise wurde auf {version} aktualisiert. Lade neu, um sie zu nutzen; nichts, was noch gesendet werden muss, geht verloren.',
  'updated.reload': 'Neu laden',
  'error.pageTitle': 'Diese Seite hat sich nicht geöffnet',
  'error.pageBody': 'Beim Öffnen ist etwas schiefgegangen. Neu laden behebt es meistens.',
  'access.waitingOne': '„{name}“ fragt Zugang von außerhalb der Küche an.',
  'access.waitingCount_one': '1 Gerät fragt Zugang von außerhalb der Küche an.',
  'access.waitingCount_other': '{count} Geräte fragen Zugang von außerhalb der Küche an.',
  'access.checkCode': 'Code prüfen und freigeben',
  'error.incompatibleUnits':
    '{child} ergibt {makes}, kann hier also nicht in {unit} abgemessen werden. Nimm dieselbe Art von Einheit oder ändere, was {child} ergibt.',
  'error.incompatibleUnitsUsedIn':
    '{usedIn} verwendet {child} in {unit}, was sich nicht aus {makes} berechnen lässt. Ändere zuerst diese Zeile oder behalte die Ausbeute in derselben Art von Einheit.',
  'recipe.shownAsWritten':
    'Dieses Rezept lässt sich nicht auf die gewünschte Menge umrechnen, deshalb steht es so da, wie es geschrieben ist.',
  'passwordOnly.signIn': 'Mit Passwort anmelden',
  'passwordOnly.staff':
    'Du bist mit deiner PIN angemeldet. Um Personal hinzuzufügen oder Rollen, Passwörter und PINs zu ändern, melde dich mit deinem Passwort an.',
  'passwordOnly.devices':
    'Du bist mit deiner PIN angemeldet. Um Tablets zu registrieren oder Geräte von außen zuzulassen, melde dich mit deinem Passwort an.',
  'passwordOnly.connection':
    'Du bist mit deiner PIN angemeldet. Um zu ändern, wie Mise erreichbar ist, melde dich mit deinem Passwort an.',
  'passwordOnly.backups':
    'Du bist mit deiner PIN angemeldet. Um Backups zu verwalten oder den Wiederherstellungsschlüssel zu sehen, melde dich mit deinem Passwort an.',
  'error.passwordRequired':
    'Melde dich dafür mit deinem Passwort an. Mit einer PIN geht alles andere.',
};
